// extracted by mini-css-extract-plugin
module.exports = {"sendEmail":"VerifyAccountScreen_sendEmail__2AADR","cta":"VerifyAccountScreen_cta__28Z5l"};